import React from 'react';
import { MapPin } from 'lucide-react';

const BG = { emerald: 'bg-emerald-600', blue: 'bg-blue-600', orange: 'bg-orange-600', yellow: 'bg-yellow-600' };

export const OFFICE_CARDS = [
  { key: 'head', color: 'emerald', fallbackName: 'Head Office', fallbackAddress: 'Noida, Uttar Pradesh', fallbackQuery: 'Noida', title: 'Head Office Location' },
  { key: 'haryana', color: 'blue', fallbackName: 'Haryana Office', fallbackAddress: 'Gurugram, Haryana', fallbackQuery: 'Gurugram', title: 'Haryana Office Location' },
  { key: 'maharashtra', color: 'orange', fallbackName: 'Maharashtra Office', fallbackAddress: 'Navi Mumbai, Maharashtra', fallbackQuery: 'Navi Mumbai', title: 'Maharashtra Office Location' },
  { key: 'rajasthan', color: 'yellow', fallbackName: 'Rajasthan Office', fallbackAddress: 'Jaisalmer, Rajasthan', fallbackQuery: 'Jaisalmer', title: 'Rajasthan Office Location' },
];

export const AboutOfficeCard = ({ office, config }) => (
  <div className="bg-gray-50 rounded-2xl overflow-hidden shadow-lg">
    <div className="p-6">
      <div className="flex items-start gap-4 mb-4">
        <div className={`w-10 h-10 ${BG[config.color]} rounded-lg flex items-center justify-center flex-shrink-0`}>
          <MapPin className="w-5 h-5 text-white" />
        </div>
        <div>
          <h3 className="text-xl font-bold text-gray-900 mb-1">{office?.name || config.fallbackName}</h3>
          <a href={office?.mapUrl} target="_blank" rel="noopener noreferrer" className="text-sm text-emerald-600 leading-relaxed hover:text-emerald-700 transition-colors duration-200 hover:underline">
            {office?.address || config.fallbackAddress}
          </a>
        </div>
      </div>
      <a href={office?.mapUrl} target="_blank" rel="noopener noreferrer" className="block aspect-video rounded-xl overflow-hidden relative group cursor-pointer" data-testid={`${config.key}-office-map`}>
        <iframe
          src={`https://www.google.com/maps?q=${encodeURIComponent(office?.address || config.fallbackQuery)}&output=embed`}
          width="100%"
          height="100%"
          style={{ border: 0, pointerEvents: 'none' }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title={config.title}
        ></iframe>
        <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors flex items-center justify-center">
          <span className={`opacity-0 group-hover:opacity-100 transition-opacity ${BG[config.color]} text-white px-3 py-1.5 rounded-lg font-medium shadow-lg text-sm`}>
            Open in Google Maps
          </span>
        </div>
      </a>
    </div>
  </div>
);
